import React from 'react';
import * as myConstClass from './constants/constants';

class CumulativeTypeDropdown extends React.Component {

  constructor(props) {
		super(props);
		this.cumulTypeChange = this.cumulTypeChange.bind(this);
		this.displaySubseasonOption = this.displaySubseasonOption.bind(this);
	}

	cumulTypeChange(event) {
		var cumulType = event.target.value;
		this.props.cumulTypeChange(cumulType);
	}

	render() {
		//console.log('CumulativeTypeDropdown: render');
		var textCumulSeason = "Cumulées pour la saison en entier";
		if(this.props.resType === myConstClass.RESTYPE_TOURNAMENT) {
			textCumulSeason = "Cumulées pour le tournoi en entier"
		}

		return (
			<select className={"form-control " + this.props.specificClass} value={this.props.value} onChange={this.cumulTypeChange}>
				<option value={0} key={"cumulType0"}>Non-cumulées</option>
					{this.displaySubseasonOption()}
				<option value={2} key={"cumulType2"}>{textCumulSeason}</option>
			</select>
		);
	}

	displaySubseasonOption() {
		var textCumulSubseason = "Cumulées par sous-saison";
		if(this.props.resType === myConstClass.RESTYPE_TOURNAMENT) {
			textCumulSubseason = "Cumulées par sous-tournoi"
		}

		if (this.props.dispSubseason) {
			return (
				<option value={1} key={"cumulType1"}>{textCumulSubseason}</option>
			);
		}
	}

}

export default CumulativeTypeDropdown;